<template>
  <div class="inner-banner breadcrumb-area-info1 main-banner" :style="bannerStyle">
    <div class="image-layer" :style="{ backgroundImage: 'url(' + bannerImage + ')' }"></div>
    <div class="container">
      <div class="row">
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
          <div class="breadcrumb-content">
            <div class="section-title white-2">
              <h4>Business</h4>
              <h1 class="mt-3">事業内容</h1>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <section class="auninfo_contact cantact_v2 section_padding margin-top-about breadcrumb-area-biz">
    <div class="container">
      <div class="block-title text-center" data-aos="fade-right" :data-aos-duration="500">
        <p><span>Business</span></p>
      </div>
      <div class="row">
        <div class="col-lg-6 d-flex flex_phone">
          <div class="my-auto">
            <div class="about-one__image wow slideInDown" data-aos="fade-right" :data-aos-duration="500" style="top:0">
              <img :src="businessMainImage" alt="" loading="lazy" style="width:100%;margin:0 auto;margin-top:50px;">
            </div>
          </div>
        </div>
        <div class="col-lg-12">
          <div class="about-one__content" v-for="(item, index) in sections" :key="item.section_key" :id="anchorId(item, index)">
            <div class="about-one__box-wrapper">
              <div class="about-one__box">
                <div class="about-one__box-icon"><i :class="item.icon || 'fa fa-hospital-user'"></i></div>
                <div class="about-one__box-content" data-aos="fade-right" :data-aos-duration="500">
                  <h3>{{ item.title }}</h3>
                  <p style="white-space:pre-line">{{ item.body }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <br/><br/>
    </div>
  </section>
</template>

<script>
const defaults = [
  {section_key:'b1', title:'専門医セカンドオピニオン（病歴資料・遠隔オンライン）', body:'日本の医療機関にご自身の病状や診断についての相談をされたい海外の患者様へのサービスです。本国での治療方法や診断に不安や不満のある患者様も多い中、患者様の納得のいく治療法を選択することができるよう、治療の進行状況、次の段階の治療選択などについて、本国で治療を受けている医療機関とは別に、違う医療機関の医師に「第2の意見」セカンドオピニオンを求めることができます。その後治療をどうするか等を判断し、そのまま本国での治療か、来日での治療を決める事も可能です。', icon:'fa fa-users-medical'},
  {section_key:'b2', title:'重症医療', body:'日本での治療を希望する海外の患者様へコーディネート、サポートを行います。受入医療機関とのマッチング、調整、資料の翻訳、治療期間中の医療通訳の手配など、日本での治療にかかわる全てをコーディネート致します。医療情報をもとに患者様の状態を確認し、治療方針、エリアや費用などについての希望事項や不安要素などを十分に考慮した上で受け入れ可能な医療機関を確認します。', icon:'fa fa-wave-pulse'},
  {section_key:'b3', title:'健診・精密検査', body:'世界のトップレベルといわれる日本の予防医学。最先端の医療機器と高い画像診断スキルにより、早期診断、早期治療につなげることが可能です。PET-CT、MRI/MRA、CT、内視鏡、超音波検査など各種検査にも対応します。', icon:'fa fa-hospital-user'},
  {section_key:'b4', title:'アンチエイジング・亜健康対策', body:'体性幹細胞による再生医療、免疫療法など、ご要望に沿った医療施設をご紹介し、治療開始から医療コーディネーターがしっかりとサポートします。', icon:'fa fa-heart-pulse'},
  {section_key:'b5', title:'美容医療', body:'しわ、しみ、たるみ、毛穴の開き、ニキビなど、老化や肌荒れの改善、アンチエイジングの施術を日本の優れた美容医療機関での受診に向けてコーディネート致します。', icon:'fa fa-syringe'}
];
export default {
  name: 'Business',
  data(){ return { sections: defaults } },
  mounted(){
    if (typeof $ !== 'undefined') {
      $.ajax({ type:'GET', url:'/api/page_content.php?page=business&_=' + new Date().getTime(), dataType:'json', success:(res)=>{ if(res && res.code===1 && res.list && res.list.length){ this.sections = res.list; } } });
    }
  },
  computed: {
    bannerImage() {
      const v = this.HomeInfo && this.HomeInfo.Images && this.HomeInfo.Images.banner_business;
      return (!v || v === '/assets/images/shape/shape-25.png') ? '/assets/images/background/banner-image-1B.png' : v;
    },
    businessMainImage() {
      const v = this.HomeInfo && this.HomeInfo.Images && this.HomeInfo.Images.business_main;
      return v || '/assets/images/choose-1.png';
    },
    bannerStyle() {
      return {
        backgroundImage: `linear-gradient(rgba(0, 25, 65, .22), rgba(0, 25, 65, .22)), url(${this.bannerImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
      };
    }
  },
  methods: {
    anchorId(item, index) {
      const key = item && item.section_key ? String(item.section_key) : '';
      if (/^business_0?[1-9]$/.test(key)) return 'b' + parseInt(key.replace('business_', ''), 10);
      return key || ('b' + (index + 1));
    }
  }
}
</script>
